import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { FiMenu, FiX, FiUser } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';

const navLinks = [
  { name: 'Home', path: '/' },
  { name: 'Music & Video', path: '/media' },
  { name: 'Tour & Events', path: '/events' },
  { name: 'The Vault', path: '/store' },
  { name: 'Social', path: '/social' },
  { name: 'The Club', path: '/community' },
];

export default function Navigation() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <nav className="sticky top-0 z-50 bg-grunge-black/95 border-b-4 border-sun-yellow shadow-lg backdrop-blur-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex-shrink-0 flex items-center">
            <NavLink to="/" className="flex items-center transition-opacity duration-300 hover:opacity-80">
              <img 
                src="https://media-manager-c.questera.ai/greta-media/fb12f51ee5b6b5b04fc36e6e38322fdbe9f21a5255319993208ee42085da62af087180258d5c6d79d895c821bb9cc720/images/aW1hZ2UvcG5n/c7ddfdef0fa977fada1e1d6f376569c5.png" 
                alt="Meredith Brooks" 
                className="h-10 md:h-12 w-auto object-contain invert brightness-0"
              />
            </NavLink>
          </div>
          
          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <NavLink
                key={link.name}
                to={link.path}
                className={({ isActive }) =>
                  `text-sm font-bold uppercase tracking-wider transition-colors duration-300 hover:text-sun-yellow ${
                    isActive ? 'text-sun-yellow border-b-2 border-sun-yellow pb-1' : 'text-gray-300'
                  }`
                }
              >
                {link.name}
              </NavLink>
            ))}
            <NavLink
              to="/profile"
              className="ml-4 p-2 bg-sun-yellow text-grunge-black rounded-full hover:bg-white transition-colors duration-300"
              title="User Profile"
            >
              <SafeIcon icon={FiUser} className="w-5 h-5" />
            </NavLink>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={toggleMenu}
              className="text-sun-yellow hover:text-white focus:outline-none p-2"
            >
              <SafeIcon icon={isOpen ? FiX : FiMenu} className="w-8 h-8" />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-grunge-black border-b border-sun-yellow/30"
          >
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
              {navLinks.map((link) => (
                <NavLink
                  key={link.name}
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  className={({ isActive }) =>
                    `block px-3 py-2 rounded-md text-base font-bold uppercase ${
                      isActive ? 'text-sun-yellow bg-gray-900' : 'text-gray-300 hover:text-sun-yellow hover:bg-gray-800'
                    }`
                  }
                >
                  {link.name}
                </NavLink>
              ))}
              <NavLink
                to="/profile"
                onClick={() => setIsOpen(false)}
                className="block px-3 py-2 rounded-md text-base font-bold uppercase text-sun-yellow hover:bg-gray-800 flex items-center gap-2"
              >
                <SafeIcon icon={FiUser} /> My Profile
              </NavLink>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
}
